import { useLocation, useNavigate } from 'react-router-dom'

import { Tabs, TabsList, TabsTrigger } from '~/shadcn/ui/tabs'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { usePortfolioTabs } from './usePortfolioTabs'

type Props = {
  content: React.ReactNode | React.ReactNode[]
}

function PortfolioTabs({ content }: Props) {
  const tabs = usePortfolioTabs()
  const location = useLocation()
  const { pathname } = location
  const navigate = useNavigate()

  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto border-b border-border pb-0">
        <Tabs
          value={pathname}
          onValueChange={(tabPath) => navigate(_getAccountPath(tabPath))}
          className="w-full pb-0">
          <PageContainer>
            <TabsList className="bg-transparent rounded-none pb-0 p-0 m-0">
              {tabs.map((tab, index) => {
                const isActive = pathname === _getAccountPath(tab.value)

                return (
                  <TabsTrigger
                    key={index}
                    value={tab.value}
                    isActive={isActive}
                    className="md:w-55">
                    {tab.icon}
                    {tab.label}
                  </TabsTrigger>
                )
              })}
            </TabsList>
          </PageContainer>
        </Tabs>
      </div>

      {content}
    </div>
  )
}

function _getAccountPath(path: string) {
  return `/account${path}`
}

export { PortfolioTabs }
